import './RunAutoTaskExecutor.scss';
import React, { useState } from 'react';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { IRunTaskModel } from '@models/document/actionsExecution/IRunTaskModel';
import { IRunAutoTaskExecutorProps } from './IRunAutoTaskExecutorProps';

const defaultSuccessText = 'Задача успешно выполнена';

export const RunAutoTaskExecutorModal: React.FC<IRunAutoTaskExecutorProps> = (props: IRunAutoTaskExecutorProps) => {
    const [errorText, setErrorText] = useState<string>();
    const [successText, setSuccessText] = useState<string>();
    const [success, setSuccess] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>();

    const getSuccessText = (message?: string) => {
        return props.successText || message || defaultSuccessText;
    };

    const messageBoxProp: IMessageDialogProps = {
        header: 'Запуск задачи',
        message: success ? '' : props.message,
        showOkButton: !success,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: success ? 'Закрыть' : props.cancelButtonText,
        loading: loading,
        size: props.modalSize,
        onConfirm: () => {
            setErrorText('');
            setSuccessText('');
            setSuccess(false);
            setLoading(true);

            const service = new DocumentExecutionService(props.docId);
            const runAutoTaskData: IRunTaskModel = {
                actionKey: props.actionKey,
                taskContext: '',
                parameters: [],
            };
            return service
                .runAutoTask(runAutoTaskData)
                .then((dto) => {
                    if (props.showSuccessText) {
                        setSuccessText(getSuccessText(dto.data));
                        setSuccess(true);
                    } else {
                        props.completeHandler && props.completeHandler(true);
                    }
                })
                .catch((error) => {
                    setErrorText(error);
                })
                .finally(() => setLoading(false));
        },
        onCancel: () => {
            // Крестик и Escape MessageDialog не знают о запуске: задачу, которая уже идёт, не бросаем.
            if (loading) return;
            props.completeHandler && props.completeHandler(success);
        },
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} successText={successText} />;
};
